<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="dismissModal()">
        <ion-icon class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'EXPORT.qrcode.title2' | translate }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="reset()">
        <ion-icon name="refresh"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding" color="light">

  <div class="font-12">
    <ion-text>{{ 'EXPORT.qrcode.msg.intro' | translate }}</ion-text>
    <ul>
      <li><p><ion-text [innerHTML]="'EXPORT.qrcode.msg.point1' | translate"></ion-text></p></li>
      <li><p><ion-text [innerHTML]="'EXPORT.qrcode.msg.point2' | translate"></ion-text></p></li>
      <li><p><ion-text [innerHTML]="'EXPORT.qrcode.msg.point3' | translate"></ion-text></p></li>
    </ul>
  </div>

  <ion-item class="ion-margin-vertical prompt-input-item" lines="none">
    <ion-text class="font-12" *ngIf="showTxt">{{ 'EXPORT.qrcode.msg.showTxt' | translate }}</ion-text>
    <ion-text class="font-12" *ngIf="!showTxt">{{ 'EXPORT.qrcode.msg.hideTxt' | translate }}</ion-text>
    <ion-note  slot="end">
      <ion-toggle color="success" [(ngModel)]="showTxt"></ion-toggle>
    </ion-note>
  </ion-item>

  <ng-container *ngIf="showTxt">
    <ion-item class="background-transparent ion-margin-vertical ion-item-no-padding" lines="none">
      <ion-label position="stacked" color="dark">{{ 'EXPORT.qrcode.topTxt' | translate }}</ion-label>
      <ion-select class="font-12 prompt-input-item" [(ngModel)]="topTxt" (ionChange)="check('top')">
        <ion-select-option [value]="''">
          {{ 'LBL.none' | translate }}
        </ion-select-option>
        <ion-select-option [value]="'title'">
          {{ 'ACCOUNT.lbl.title' | translate }}
        </ion-select-option>
        <ion-select-option [value]="'name'">
          {{ 'GUEST.lbl.guest_name' | translate }}
        </ion-select-option>
      </ion-select>
    </ion-item>

    <ion-item class="background-transparent ion-margin-vertical ion-item-no-padding" lines="none">
      <ion-label position="stacked" color="dark">{{ 'EXPORT.qrcode.bottomTxt' | translate }}</ion-label>
      <ion-select class="font-12 prompt-input-item" [(ngModel)]="bottomTxt" (ionChange)="check('bottom')">
        <ion-select-option [value]="''">
          {{ 'LBL.none' | translate }}
        </ion-select-option>
        <ion-select-option [value]="'title'">
          {{ 'ACCOUNT.lbl.title' | translate }}
        </ion-select-option>
        <ion-select-option [value]="'name'">
          {{ 'GUEST.lbl.guest_name' | translate }}
        </ion-select-option>
      </ion-select>
    </ion-item>
  </ng-container>

  <ion-card>
    <ion-card-header class="ion-text-center font-underline font-bold">
      {{ 'BTN.preview' | translate }}
    </ion-card-header>
    <ion-card-content class="ion-text-center">
      <ion-text class="font-14" color="black" *ngIf="showTxt && topTxt">
        <ng-container *ngIf="topTxt === 'title'">{{ 'ACCOUNT.lbl.title' | translate }}</ng-container>
        <ng-container *ngIf="topTxt === 'name'">{{ 'GUEST.lbl.guest_name' | translate }}</ng-container>
      </ion-text>
      <div class="qrcodeDiv vertical-center" *ngIf="config" #qrcodeDiv>
        <ngx-qrcode-styling class="qrcode-styling center" [data]="'https://thebigdays.com'" [config]="config"></ngx-qrcode-styling>
        <ng-container>
          <ion-img class="qrcode-logo" [style.width.px]="logoWidth" [style.height.px]="logoWidth"  [src]="logoUrl ? logoUrl : './assets/wedding/img/logo/thebigday-logo-round-primary.webp'"></ion-img>
        </ng-container>
      </div>
      <ion-text class="font-14" color="black" *ngIf="showTxt && bottomTxt">
        <ng-container *ngIf="bottomTxt === 'title'">{{ 'ACCOUNT.lbl.title' | translate }}</ng-container>
        <ng-container *ngIf="bottomTxt === 'name'">{{ 'GUEST.lbl.guest_name' | translate }}</ng-container>
      </ion-text>
    </ion-card-content>
  </ion-card>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-button class="ion-margin" expand="block" (click)="export()">
      {{ 'LBL.start' | translate }}
    </ion-button>
    <div class="font-10 ion-text-center ion-margin">
      {{ 'EXPORT.qrcode.msg.start' | translate }}
    </div>
  </ion-toolbar>
</ion-footer>
